// extracted by mini-css-extract-plugin
export default {"container":"LI-z","dimension":"MI-z","dimensionLabels":"NI-z"};